import script from "./Siding11Accents.vue?vue&type=script&setup=true&lang=js"
export * from "./Siding11Accents.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__